export default __webpack_public_path__ + "static/gold-foil-a3ea0f9e95a44f8c48a975ff980df635.jpg";